export var ThemeEnum;
(function (ThemeEnum) {
    ThemeEnum["LIGHT"] = "light";
    ThemeEnum["DARK"] = "dark";
    ThemeEnum["HIGH_CONTRAST"] = "highContrast";
})(ThemeEnum || (ThemeEnum = {}));
